<template lang='pug'>
  .sign-out.auth.component( @click='out' ) {{ $t('Sign Out') }}
</template>

<script>
  import { auth } from '@/main'
  
  export default {
    name: 'sign-out.auth.component',

    props: {
      to: { type: String, default: '/' }
    },

    methods: {
      out() {
        auth.signOut().then( snap => this.$emit('signed-out') )
        this.$router.push( this.to )
      }
    }
  }
</script>

<style scoped lang='stylus'>

</style>